import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
export class SelectOption {
  label: string;
  value?: string;
  group?: SelectOption[];
  disabled?: boolean;
/**
 * @param {?} label
 * @param {?=} value
 * @param {?=} children
 */
constructor(label: string, value?: string, children?: SelectOption[]) {
    this.label = label;
    this.value = value;
    this.group = children;
  }
}

function SelectOption_tsickle_Closure_declarations() {
/** @type {?} */
SelectOption.prototype.label;
/** @type {?} */
SelectOption.prototype.value;
/** @type {?} */
SelectOption.prototype.group;
/** @type {?} */
SelectOption.prototype.disabled;
}

export class FormlyFieldSelect extends FieldType {
/**
 * @return {?}
 */
get labelProp(): string { return this.to.labelProp || 'label'; }
/**
 * @return {?}
 */
get valueProp(): string { return this.to.valueProp || 'value'; }
/**
 * @return {?}
 */
get groupProp(): string { return this.to.groupProp || 'group'; }
/**
 * @return {?}
 */
get selectOptions() {
    let /** @type {?} */ options: SelectOption[] = [];
    this.to.options.map((option: SelectOption) => {
      if (!option[this.groupProp]) {
        options.push(option);
      } else {
        let /** @type {?} */ filteredOption: SelectOption[] = options.filter((filteredOption) => {
          return filteredOption.label === option[this.groupProp];
        });
        if (filteredOption[0]) {
          filteredOption[0].group.push({
            label: option[this.labelProp],
            value: option[this.valueProp],
          });
        }
        else {
          options.push({
            label: option[this.groupProp],
            group: [{ value: option[this.valueProp], label: option[this.labelProp] }],
          });
        }
      }
    });
    return options;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-field-select',
  template: `
    <select [formControl]="formControl" class="form-control" [class.is-invalid]="showError" [formlyAttributes]="field">
      <option value="" *ngIf="to.placeholder">{{ to.placeholder }}</option>
      <ng-container *ngFor="let item of selectOptions">
       <optgroup *ngIf="item.group" label="{{item.label}}">
         <option *ngFor="let child of item.group" [value]="child.value" [disabled]="item.disabled">
           {{ child.label }}
         </option>
       </optgroup>
       <option *ngIf="!item.group" [value]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
      </ng-container>
    </select>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldSelect_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldSelect.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldSelect.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
